export enum OfferStatusEnum {
    NEW = 1,
    APPROVED = 2,
    REJECTED = 3
}
